import React, { FC, forwardRef } from 'react';
import { FieldOptionBase } from 'api/tasks';
import { UserTag } from 'components/atoms/select';
import { useTranslate } from 'hooks/use-translation';
import { fullName } from 'utils/full-name';
import { getRandomColor } from 'utils/get-random-color';
import { SingleUserField } from '../fields';
import { getUserOptions } from './assignee';
import { EditableUserRelatedFieldProps } from './editable-props';
import { NoValue } from './no-value';
import { StyledSelect } from './styled-select';

interface Props extends EditableUserRelatedFieldProps<number> {
  field: SingleUserField;
}

export const SingleUserFieldValue: FC<Props> = forwardRef(
  ({ field, editable, project_id, is_private, onChange }, ref) => {
    const { users } = field.metaData;
    const translate = useTranslate();
    const selected_user = users.by_user_id[field.value!];

    return !editable ? (
      selected_user == null ? (
        <NoValue />
      ) : (
        <UserTag
          color={getRandomColor(selected_user.userId)}
          imageUrl={selected_user.photoUrl}
          label={fullName(selected_user)}
          userStatus={selected_user?.userStatus}
        />
      )
    ) : (
      <StyledSelect
        ref={ref}
        type="user"
        isClearable
        menuIsOpen
        options={getUserOptions(translate, users, project_id, is_private)}
        value={
          [selected_user].filter(Boolean).map((x) => ({
            label: fullName(x!),
            description: x!.role?.roleName,
            imageUrl: x!.photoUrl,
            value: x!.userId,
            color: getRandomColor(x!.userId),
          }))[0]
        }
        onChange={(latest: FieldOptionBase) => onChange?.(latest?.value)}
      />
    );
  },
);
